import api from "services/api";

// Get all tasks
export const getTasks = async () => {
  return api.get("/v1/api/tasks/get");
};

// Get tasks with query params (project_id, assigned_to)
export const getTasksWithParams = async (params) => {
  return api.get("/v1/api/tasks/get", { params });
};

// Get top 10 priority tasks (not done yet, sorted by due date & priority)
export const getTopPriorityTasks = async (params) => {
  return api.get("/v1/api/tasks/top-priority", { params });
};

// Create a new task
export const createTask = async (taskData, config = {}) => {
  return api.post("/v1/api/tasks/create", taskData, config);
};

// Update a task
export const updateTask = async (taskId, taskData) => {
  return api.patch(`/v1/api/tasks/update/${taskId}`, taskData);
};

// Update task status (supports FormData with optional review & deliverables)
export const updateTaskStatus = async (taskId, statusData) => {
  const isFormData = statusData instanceof FormData;
  return api.post(
    `/v1/api/tasks/update-status/${taskId}`,
    statusData,
    isFormData
      ? {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      : undefined
  );
};

export const createTaskReview = async (taskId, reviewData) => {
  const isFormData = reviewData instanceof FormData;
  return api.post(`/v1/api/tasks/review/${taskId}`, reviewData, {
    headers: {
      "Content-Type": isFormData ? "multipart/form-data" : "application/json",
    },
  });
};

// Delete a task
export const deleteTask = async (taskId) => {
  return api.delete(`/v1/api/tasks/delete/${taskId}`);
};

export const getEmployeeTaskDateRanges = async (employeeId) => {
  return api.get(`/v1/api/tasks/date-ranges/${employeeId}`);
};

// Get team tasks (tasks assigned to reportees in org tree)
export const getTeamTasks = async (params) => {
  return api.get("/v1/api/tasks/team-tasks", { params });
};
